const graphqlCacheConfig = {
  typePolicies: {
    ConfigMap: {
      keyFields: false,
      merge: true,
    },
    ContestProfile: {
      keyFields: ['memberId'],
    },
    PriceReport: {
      fields: {
        credit: {
          merge: true,
        },
      },
    },
    Recall: {
      keyFields: ['recall_id'],
      merge: true,
    },
    Review: {
      keyFields: ['reviewId'],
    },
    Station: {
      fields: {
        address: {
          merge: true,
        },
        prices: {
          merge: false,
        },
      },
    },
    Vehicle: {
      keyFields: ['guid'],
      merge: true,
    },
    FuelLog: {
      keyFields: ['guid'],
      merge: true,
    },
  },
};

export default graphqlCacheConfig;
